/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_Cat_5Inputs */

const en_mk_context_cat_5 = /** @type {(inputs: Mk_Context_Cat_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work Rhythm`)
};

const id_mk_context_cat_5 = /** @type {(inputs: Mk_Context_Cat_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritme Kerja`)
};

/**
* | output |
* | --- |
* | "Work Rhythm" |
*
* @param {Mk_Context_Cat_5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_cat_5 = /** @type {((inputs?: Mk_Context_Cat_5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_Cat_5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_cat_5(inputs)
	return en_mk_context_cat_5(inputs)
});